import {
  getAdjustedDate,
  getStartDates,
  getEndDates,
} from "../../../../../../legacyComponents/util/helperFunctions";

export default {
  nullOption() {
    return { display: "", value: null };
  },

  nullPlanOption() {
    return { name: "", planType: null };
  },

  nullDateOption() {
    return { display: "", value: null, dateString: null };
  },

  plans(employer) {
    return employer?.availablePlans;
  },

  midYearPlan: [
    {
      display: "No, we are switching to Salusion the following plan year",
      value: false,
    },
    {
      display: "Yes, we are switching to Salusion this current plan year",
      value: true,
    },
  ],

  startDates(isCustomer) {
    const currentDate = getAdjustedDate({ date: new Date() });
    let currentMonth = currentDate.getMonth();
    let currentYear = currentDate.getFullYear();
    // currentMonth += 1
    // if (currentMonth > 11) {
    // 	currentMonth = 0
    // 	currentYear += 1
    // }

    let minDate = getAdjustedDate({ date: new Date(currentYear, 0, 1) });
    if (isCustomer)
      minDate = getAdjustedDate({
        date: new Date(currentYear, currentMonth, 1),
      });

    const maxDate = getAdjustedDate({ date: new Date(currentYear + 1, 5, 1) });

    return getStartDates({ minDate, maxDate, monthYearOnly: true });
  },
  midPlanYearStartDates() {
    const currentDate = getAdjustedDate({ date: new Date() });
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    let minDate = getAdjustedDate({
      date: new Date(currentYear - 1, currentMonth + 1, 1),
    });

    const maxDate = getAdjustedDate({ date: new Date(currentYear + 1, 5, 1) });

    return getStartDates({ minDate, maxDate, monthYearOnly: true });
  },

  endDates(minDate) {
    const minMonth = minDate.getMonth();
    const minYear = minDate.getFullYear();
    const maxDate = getAdjustedDate({
      date: new Date(minYear + 1, minMonth, 0),
    });

    return getEndDates({ minDate, maxDate, monthYearOnly: true });
  },
  excludedClasses: {
    QSEHRA: [
      {
        display: "Include all employees",
        value: "NO_EXCLUDED_EMPLOYEES",
      },
      {
        display: "Exclude employees with < 30 days of service",
        value: "LESS_THAN_30_DAYS_OF_SERVICE",
      },
      {
        display: "Exclude employees with < 60 days of service",
        value: "LESS_THAN_60_DAYS_OF_SERVICE",
      },
      {
        display: "Exclude employees with < 90 days of service",
        value: "LESS_THAN_90_DAYS_OF_SERVICE",
      },
      {
        display: "Exclude employees under 25 at the plan‑year start",
        value: "LESS_25_YEARS_OLD",
      },
      {
        display: "Exclude part‑time employees",
        value: "PART_TIME",
      },
      {
        display: "Exclude seasonal employees",
        value: "SEASONAL",
      },
      {
        display:
          "Exclude employees covered by a collective‑bargaining agreement who do not elect to participate",
        value: "UNDER_COLLECTIVE_BARGAINING_AGREEMENT",
      },
      // {
      // 	display: "Exclude non‑resident aliens without U.S.‑sourced earned income",
      // 	value: "NON_RESIDENT_ALIENS_WITH_NO_US_SOURCED_INCOME"
      // }
    ],
  },

  predefinedClasses: {
    ICHRA: [
      {
        display: "Full-time employees",
        value: "FULL_TIME",
      },
      {
        display: "Part‑time employees",
        value: "PART_TIME",
      },
      {
        display: "Seasonal employees",
        value: "SEASONAL",
      },
      {
        display: "Employees who are paid on a salaried basis",
        value: "SALARIED",
      },
      {
        display:
          "Employees who are paid on a non-salaried basis (e.g. hourly employees)",
        value: "NON_SALARIED",
      },
      {
        display:
          "Employees whose primary site of employment is in one the following states or rating areas",
        value: "RATING",
      },
      {
        display: "Employees with < 30 days of service",
        value: "LESS_THAN_30_DAYS_OF_SERVICE",
      },
      {
        display: "Employees with < 60 days of service",
        value: "LESS_THAN_60_DAYS_OF_SERVICE",
      },
      {
        display: "Employees with < 90 days of service",
        value: "LESS_THAN_90_DAYS_OF_SERVICE",
      },
      {
        display:
          "Employees who have not satisfied a waiting period for coverage",
        value: "WAITING",
      },
      {
        display:
          "Employees hired for temporary placement at an unrelated entity",
        value: "TEMP",
      },
      {
        display:
          "Employees included in a unit covered by a collective bargaining agreement",
        value: "CBA",
      },
      // {
      // 	display: "Nonresident aliens with no U.S.-based income",
      // 	value: "NON_RESIDENT"
      // }
    ],
    QSEHRA: [
      {
        display: "Include all employees",
        value: "ALL_ELIGIBLE_EMPLOYEES",
      },
      {
        display: "Exclude employees with < 30 days of service",
        value: "LESS_THAN_30_DAYS_OF_SERVICE",
      },
      {
        display: "Exclude employees with < 60 days of service",
        value: "LESS_THAN_60_DAYS_OF_SERVICE",
      },
      {
        display: "Exclude employees with < 90 days of service",
        value: "LESS_THAN_90_DAYS_OF_SERVICE",
      },
      {
        display: "Exclude employees under 25 at the plan‑year start",
        value: "LESS_25_YEARS_OLD",
      },
      {
        display: "Exclude part‑time employees",
        value: "PART_TIME",
      },
      {
        display: "Exclude seasonal employees",
        value: "SEASONAL",
      },
      {
        display:
          "Exclude employees covered by a collective‑bargaining agreement who do not elect to participate",
        value: "UNDER_COLLECTIVE_BARGAINING_AGREEMENT",
      },
      // {
      // 	display: "Exclude non‑resident aliens without U.S.‑sourced earned income",
      // 	value: "NON_RESIDENT_ALIENS_WITH_NO_US_SOURCED_INCOME"
      // }
    ],

    EBHRA: [
      {
        display: "All Eligible Employees",
        value: "ALL_ELIGIBLE_EMPLOYEES",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],
    GCHRA: [
      {
        display: "All Eligible Employees",
        value: "ALL_ELIGIBLE_EMPLOYEES",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],
  },

  // employeeClasses: [
  // 	{
  // 		display: "Include all employees",
  // 		value: "NONE"
  // 	},
  // 	{
  // 		display: "Exclude employees with < 30 days of service",
  // 		value: "LESS_THAN_30_DAYS_OF_SERVICE"
  // 	},
  // 	{
  // 		display: "Exclude employees with < 60 days of service",
  // 		value: "LESS_THAN_60_DAYS_OF_SERVICE"
  // 	},
  // 	{
  // 		display: "Exclude employees with < 90 days of service",
  // 		value: "LESS_THAN_90_DAYS_OF_SERVICE"
  // 	},
  // 	{
  // 		display: "Exclude employees under 25 at the plan‑year start",
  // 		value: "LESS_25_YEARS_OLD"
  // 	},
  // 	{
  // 		display: "Exclude part‑time employees",
  // 		value: "PART_TIME"
  // 	},
  // 	{
  // 		display: "Exclude seasonal employees",
  // 		value: "SEASONAL"
  // 	},
  // 	{
  // 		display: "Exclude employees covered by a collective‑bargaining agreement who do not elect to participate",
  // 		value: "UNDER_COLLECTIVE_BARGAINING_AGREEMENT"
  // 	},
  // 	{
  // 		display: "Exclude non‑resident aliens without U.S.‑sourced earned income",
  // 		value: "NON_RESIDENT_ALIENS_WITH_NO_US_SOURCED_INCOME"
  // 	}
  // ],

  qualifiedBenefits: {
    ICHRA: [
      {
        display: "Premiums Only",
        value: "QUALIFIED",
      },
      {
        display: "Premiums and Other Medical Expenses",
        value: "SECTION_213D",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],

    QSEHRA: [
      {
        display:
          "Premiums and Other Medical Expenses (Excluding Taxable Premiums)",
        value: "NON_TAXABLE_PREMIUMS_EXPENSES",
      },
      {
        display: "Premiums and Other Medical Expenses",
        value: "SECTION_213D",
      },
      {
        display: "Premiums Only (Excluding Taxable Premiums)",
        value: "NON_TAXABLE_PREMIUMS",
      },
      {
        display: "Premiums Only",
        value: "QUALIFIED",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],

    GCHRA: [
      {
        display: `Out of Pocket Medical Expenses excluding premiums for Individual Health Coverage, Medicare, and Non-COBRA Group Coverage`,
        value: "SECTION_213D_EXCEPT",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],

    EBHRA: [
      {
        display: `Out of Pocket Medical Expenses excluding premiums for Individual Health Coverage, Medicare, and Non-COBRA Group Coverage`,
        value: "SECTION_213D_EXCEPT",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],

    THRA: [
      {
        display: "Premiums + out‑of‑pocket medical expenses",
        value: "SECTION_213D",
      },
      {
        display: "Other",
        value: "OTHER",
      },
    ],
  },

  maxBenefits: {
    ICHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
      {
        display: "Vary by family size",
        value: "FAMILY",
      },
      {
        display: "Vary by age",
        value: "AGE",
      },
      {
        display: "Vary by age and family size",
        value: "FAMILY_AGE",
      },
    ],

    QSEHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
      {
        display: "Vary by family size",
        value: "FAMILY",
      },
      {
        display: "Vary by age",
        value: "AGE",
      },
      {
        display: "Vary by age and family size",
        value: "FAMILY_AGE",
      },
    ],

    EBHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
    ],

    GCHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
      {
        display: "Vary by family size",
        value: "FAMILY",
      },
    ],
  },
  maxBenefitsSelfOnly: {
    ICHRA: [
      {
        display: "Same Amount for All Employees",
        value: "SELF",
      },
      {
        display: "Vary by age",
        value: "AGE",
      },
    ],

    QSEHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
      {
        display: "Vary by family size",
        value: "FAMILY",
      },
      {
        display: "Vary by age",
        value: "AGE",
      },
      {
        display: "Vary by age and family size",
        value: "FAMILY_AGE",
      },
    ],

    EBHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
    ],

    GCHRA: [
      {
        display: "Same amount for all employees",
        value: "SELF",
      },
    ],
  },
  acaCalculations: [
    {
      display: "Calculate based on salary = Federal Poverty Level",
      value: "FEDERAL",
    },
    {
      display: "Calculate based on entering a minimum Salary",
      value: "SALARY",
    },
  ],

  acaAdjustmentTypes: [
    {
      display: "Are plan allocations a Equal Amount for All Employees?",
      value: "SELF",
    },
    {
      display: "Are plan allocations based on Family Size?",
      value: "FAMILY",
    },
  ],

  reimbursementMethods: [
    { display: "Employer reimburses employees directly", value: "OTHER" },
    {
      display: "Salusion reimburses employees through ACH direct deposit",
      value: "SALUSION",
    },
  ],
  reimbursementMethodsNoACH: [
    { display: "Employer reimburses employees directly", value: "OTHER" },
  ],

  reimbursementTimings: [
    { display: "As expenses are approved", value: "DAILY" },
    { display: "On two scheduled dates each month", value: "MONTHLY" },
  ],
  reportTimings: [
    { value: "MONTHLY", display: "1st of each month" },
    { value: "SEMI_MONTHLY", display: "1st and 16th of each month" },
  ],

  accountTypes: ["Checking", "Savings"],
};
